// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__svfdx","footerCardView":"footer_footerCardView__ZQ7UJ","footerLink":"footer_footerLink__7y-c+","footerLinkCardView":"footer_footerLinkCardView__UKaDJ"};